<template>
    <div>
        <div class="ProductOnSale">
            <div style="display: flex;justify-content: space-between">
                <div style="display: flex;">
                    <el-select v-model="state" placeholder="请选择" size="mini" @change="changeState">
                        <el-option
                                v-for="item in stateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input
                            style="width: 220px"
                            size="mini"
                            class="input"
                            placeholder="搜索品种或标题"
                            v-model="vc_search"
                            clearable>
                    </el-input>
                    <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
                </div>

                <!--<el-select v-model="state" placeholder="请选择" size="mini">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>-->
            </div>
            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true"
                    style="width: 100%">
                <el-table-column
                        label="编号"
                        align="center"
                        prop="code" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="状态"
                        prop="stateTxt" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="标题"
                        prop="title" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="发布时间"
                        sortable
                        prop="publishtime" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="截止时间"
                        sortable
                        prop="duetime" show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        align="center"
                        label="人员"
                        prop="creatorName" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="录入时间"
                        sortable
                        prop="createTime" show-overflow-tooltip>
                </el-table-column>

                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button  size="mini" type="text" @click="details(scope.row)"  >{{scope.row.state==2?'查看报价供应商':'查看报价'}}</el-button>
                        <el-button  size="mini" type="text" @click="seeZb(scope.row)"  v-if="scope.row.i_res_id" >查看中标</el-button>

                        <!--                    <el-button  size="mini" type="text" @click="stopAccept(scope.row)" v-if="scope.row.state==2" :disabled="disrow">截止</el-button>-->
                        <!--                    <el-button  size="mini" type="text" v-if="scope.row.state==1" @click="fabu(scope.row)" :disabled="disrow">发布</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="pageCurrentChange"
                            layout="total,prev, pager, next"
                            :current-page.sync="currentPage"
                            :total="total"
                            :page-size="pageSize">
            </el-pagination>
            <div :class="baseerp+'div'">
                <el-dialog :title="title"
                           width="95%"
                           top="30px"
                           :visible.sync="dialogTableVisible"
                           :close-on-click-modal="false"
                           @close="closeDetailsFun">

                    <offer-list :offerData="offerData" v-if="dialogTableVisible" @close="closeDetailsFun" @bidsList="bidsList" @look="lookreport"></offer-list>
                </el-dialog>
                <el-dialog title="查看中标"
                           width="90%"
                           :visible.sync="confirmdialog"
                           :close-on-click-modal="false"
                           >
                    <confirm-offer :confirmData="confirmData" @close="closeConfirm"  v-if="confirmdialog" @bidsList="bidsList" ></confirm-offer>
                </el-dialog>
            </div>
            <div class="contentLeft">
                <reportdialog  ref="mydialog"  ></reportdialog>
                <eDialog ref="eDialog" :activePage="activePage"></eDialog>
            </div>
        </div>
    </div>
</template>

<script>
    import * as API from "../api";
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    // import TenderList from "../compontents/TenderList";
    import OfferList from "./compontents/OfferList";
    import ConfirmOffer from "./compontents/ConfirmOffer";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        name: "index",
        components: {OfferList,
            // TenderList,
            ConfirmOffer,reportdialog,eDialog},
        data() {
            return {
                activePage:"report/res/spread.vue",
                offerData:{},
                tableData:[],
                treespan:4,
                rightspan:20,
                showDetails:false,
                baseerp: "",
                dialogTableVisible:false,
                pageSize:20,
                currentPage:0,
                total:0,
                title:'新增招标',
                state:null,
                stateList:[
                    {value:null,label:'全部状态'},
                    {value:2,label:'招标中'},
                    {value:4,label:'开标中'},
                    {value:5,label:'招标结束'},
                ],
                tableHeight:0,
                disrow:false,
                confirmData:{},
                confirmdialog:false,
                vc_search:'',
            }
        },
        mounted() {
            this.baseerp=baseerp
            this.bidsList();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            lookreport() {
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                if(this.offerData.state==2){
                    this.$refs.eDialog.showDialog({
                        title:"报价供应商明细结果报表",
                        parm:{type:'PurchaseOfferSupplier',mid:this.$route.meta.mid,arg:{i_bid_id:this.offerData.id}},
                        w:1024,
                        h:768
                    });
                }else{
                    this.$refs.eDialog.showDialog({
                        title:"报价明细结果报表",
                        parm:{type:'RequireOfferRpt',mid:this.$route.meta.mid,arg:{i_bid_id:this.offerData.id}},
                        w:1024,
                        h:768
                    });
                }

                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                });
                // console.log(res)
            },
            details(row){
                this.offerData=row;
                this.offerData.i_mid=this.mid
                this.offerData.i_hasOpenRight=this.i_hasOpenRight
                this.dialogTableVisible=true
                this.title="查看标"+row.code+"报价详情"
            },
            seeZb(row){
                this.confirmData=row;
                this.confirmData.i_mid=this.mid
                this.confirmdialog=true
            },
            changeState(val){
                this.state=val
                this.currentPage=1
                this.bidsList()
            },
            searchData(){
                this.currentPage=1
                this.bidsList()
            },
            async bidsList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
                let param={
                    i_mid: this.mid,
                    id:0,
                    pzId:0,
                    i_state:this.state,
                    keyword:'',
                    duetime:'',
                    pageSize:this.pageSize,
                    currentPage:this.currentPage,
                    isPublished:1,
                    vc_search:this.vc_search
                };
                let res=await API.bidsList(param);
                if ( res.code == 1 ){
                    this.disrow=false
                    // console.log(res.data.list)
                    this.tableData=res.data.list;
                    this.i_hasOpenRight=res.data.i_hasOpenRight
                    this.total=res.data.total;
                    // console.log(this.tableData,"this.tableData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            async stopAccept(row){
                this.disrow=true
                let param={
                    id:row.id,
                };
                let res=await API.stopAccept(param);
                if ( res.code == 1 ){
                    // this.disrow=false
                    this.$message.success(res.message);
                    this.bidsList()
                }else if (res.code == -2) {
                    this.disrow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disrow=false
                    this.$message.error(res.message);
                }
            },
            async fabu(row){
                this.disrow=true
                let param={
                    id:row.id,
                };
                let res=await API.publish(param);
                if ( res.code == 1 ){
                    // this.disrow=false
                    this.$message.success(res.message);
                    this.bidsList()
                }else if (res.code == -2) {
                    this.disrow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disrow=false
                    this.$message.error(res.message);
                }
            },

            showDetailsFun(){
                this.dialogTableVisible=true
            },
            closeDetailsFun(type='back'){
                this.dialogTableVisible=false
                this.offerData={}
            },
            closeConfirm(){
                this.confirmdialog=false
                this.confirmData={}
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.bidsList();
            },
        },

    }
</script>

<style lang="scss" scoped>
    .ProductOnSale{
        margin: 10px 14px;
    }
    .mrt10{
        margin-top: 10px;
    }
    /deep/{
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-dialog{
            margin:30px auto;
        }
    }
</style>